import CustomIcon from "components/WasteTypeCustomIcon/WasteTypeCustomIcon";
import IContainerStatusViewModel from "interfaces/IContainerStatusViewModel";
import { useCallback, useState } from "react";

const ContainerTemplate = (props: IContainerStatusViewModel): any => {
  const { id, wasteTypeId } = props;
  const [, setIconLoaded] = useState<boolean>(false);

  const container = { props };
  const handleOnCompleted = useCallback(
    _ => setIconLoaded(true),
    [setIconLoaded]
  );

  const handleIconError = useCallback(
    _ => setIconLoaded(false),
    [setIconLoaded]
  );

  const renderColumnValue = (): any => (
    <>
      <CustomIcon
        id={id}
        wasteTypeId={wasteTypeId}
        onCompleted={handleOnCompleted}
        onError={handleIconError}
      />
      <span className="ms-1 fw-bold">{container.props.wasteType}</span>
      <br />
      <span className="size-header">
        {container.props.size}
        &nbsp;
        {`${container.props.name}`}
      </span>
    </>
  );

  return renderColumnValue();
};
export default ContainerTemplate;
